export default {
  reg: {
    letter: 'Sono ammesse solo lettere inglesi e spazi',
  },
}
